import React, { useState } from 'react';
import { MailOutlined } from '@ant-design/icons';
import { Button, Form, Input, Typography } from 'antd';
import styles from './ForgotPasswordForm.module.css';

// email for reset password request
export interface ResetPasswordRequestInfo {
  email: string
};

export interface ForgotPasswordFormProps {
  handleResetPasswordRequest: (info: ResetPasswordRequestInfo) => Promise<void>
};

// form used on forgot password page
const ForgotPasswordForm = (props: ForgotPasswordFormProps): JSX.Element | null => {
  // reset password request call enabled/disabled state
  const [requestDisabled, setRequestDisabled] = useState<boolean>(false);

  // handle reset password request
  const handleResetPasswordRequest = (info: ResetPasswordRequestInfo) => {
    if (requestDisabled) {
      return;
    }

    setRequestDisabled(true);
    props.handleResetPasswordRequest(info).finally(
      () => setRequestDisabled(false)
    );
  };

  return (
    <Form
      name='basic'
      layout={'vertical'}
      initialValues={{ remember: true }}
      onFinish={handleResetPasswordRequest}
    >
      <Form.Item
        label={
          <Typography.Text
            className={styles.formLabel}
          >
            Enter your email to initiate password recovery
          </Typography.Text>
        }
        name='email'
        rules={[
          {
            type: 'email',
            message: (
              <Typography.Text
                className={styles.formAlert}
              >
                Please enter a valid email
              </Typography.Text>
            )
          },
          {
            required: true,
            message: (
              <Typography.Text
                className={styles.formAlert}
              >
                Please enter an email
              </Typography.Text>
            )
          }
        ]}
      >
        <Input
          name='email'
          placeholder='Enter email'
          prefix={<MailOutlined />}
          disabled={requestDisabled}
        />
      </Form.Item>
      <Form.Item className={styles.submitButtonContainer}>
        <Button
          type='primary'
          htmlType='submit'
          loading={requestDisabled}
          className='mainButton'
        >
          Reset Password
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ForgotPasswordForm;
